module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showBackDrop) ? _c('div', {
    staticClass: "ui dimmer page",
    staticStyle: {
      "display": "block !important"
    },
    style: ({
      visibility: _vm.showBackDrop ? 'visible' : 'hidden',
      opacity: _vm.showBackDrop ? '1' : '0'
    })
  }, [_c('transition', {
    attrs: {
      "name": "scale"
    }
  }, [_c('div', {
    staticClass: "ui center aligned middle aligned grid constatus"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('i', {
    staticClass: "signal huge icon red"
  }), _vm._v(" "), _c('h1', [_vm._v("Connection to Server Lost!")]), _vm._v(" "), _c('h2', [_vm._v("Trying to reconnect")]), _vm._v(" "), _c('span', {
    staticClass: "ui active inline loader"
  })])])])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5e9c9f44!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConStatus.vue
// module id = 451
// module chunks = 28